export const localisable = {
    //Footer items
    privacyPolicy: 'Privacy Policy',
    poweredBy: 'Powered By',
    termsAndConditions: 'Terms and Conditions',
    //FAQ items
    frequentlyAskedQuestions: 'Frequently Asked Questions',

    //Unit availability items
    storageUnits: 'Storage Units',
    unitAvailability: 'Unit Availability',
    rate: 'Rate',
    deposit: 'Deposit',
    climateControl: 'Climate Control',
    outdoorParking: 'Outdoor Parking',
    mobile: 'Mobile',
    autoMobile: 'Auto Mobile',

    //Select Location items
    facility: 'Facility',
    address: 'Address',

    //contact us items
    label: 'Label',
    enterName: 'Enter Name',
    enterPhoneNumber: 'Enter Phone Number',
    enterEmail: 'Enter Email',
    enterSubject: 'Enter Subject',
    enterMessage: 'Enter Message',
    clear: 'Clear',
    closed: 'Closed',
    is24HoursOpen: '24 hours a day, 7 days a week',
    name: 'Name',
    phone: 'Phone Number',
    emailAddress: 'Email Address',
    subject: 'Subject',
    message: 'Message',
    contactThankyouMessage: 'Thank you for contacting us, We will get back to you soon.',

    //login items
    payRent: 'Pay Rent',
    signUpForAutoPay: 'Sign Up for AutoPay',
    updateTenantInformation: 'Update Tenant Information',
    userName: 'User Name',
    password: 'Password',
    enterYourName: 'Enter Your Name',
    enterYourPassword: 'Enter Your Password',
    forgotPassword: 'Forgot Password',
    changePassword: 'Change Your Password',
    howToLogin: 'How to Login',
    userNameExp: "First Initial + Tenant's Last Name",
    passwordExp: "Tenant's First Unit Number",
    example: 'Example',
    exampleLine1: "John Smith's First Unit Number 1234",
    exampleLine2: "John's Username: jsmith",
    exampleLine3: "John's Password: 1234",
    haveQuestions: 'Have questions about your account?',
    forgotPasswordHeader: 'Login Required for Changing the Password',
    userNameAndCredentialsError: 'Either the supplied username does not exist, or the supplied credentials are incorrect. Please try again.',
    credentialsError: 'Supplied credentials are incorrect. Please try again.',
    close: 'Close',
    login: 'Login',
    goBack: 'Go Back',
    email: 'Email',
    send: 'Send',
    token: 'Token',
    enterYourEmail: 'Enter Your Email',
    enterToken: 'Enter Token',
    verifyCode: 'Verify Code',
    newPassword: 'New Password',
    repeatPassword: 'Repeat Password',
    enterPassword: 'Enter Password',
    reset: 'Reset',
    passwordChangeSuccess: 'Password Changed Successfully.',
    goToPayment: 'Go To Payment',
    enterOldPassword: 'Please Enter Old Password',
    enterNewPassword: 'Please Enter New Password',
    reEnterNewPassword: 'Re-Enter New Password',
    change: 'Change',
    payment: 'Payment',
    paymentSuccessful: 'Payment is successful',
    cardType: 'Card Type',
    balanceDue: 'Balance Due',
    otherAmount: 'Other Amount',
    amount: 'Amount',
    balanceDetail: 'Balance details',
    useExistingCard: 'Use Existing Card',
    useNewCard: 'Use New Card',
    accountNumber: 'Account Number',
    accountName: 'Account Name',
    expirationMonth: 'Expiration Month',
    expirationYear: 'Expiration Year',
    accountBillingAddress: 'Account Billing Address',
    billingZip: 'Billing Zip',
    achAccountNumber: 'ACH Account Number',
    achRoutingNumber: 'ACH Routing Number',
    makePayment: 'Make a Payment',
    logOff: 'Log Off',
    balance: 'Balance',
    lastPaymentReceived: 'Last Payment Received',
    lastPaymentAmount: 'Last payment amount',
    fromDate: 'From Date',
    toDate: 'To Date',
    description: 'Description',
    amountOwed: 'Amount Owed',
    comments: 'Comments',
    surcharge: 'Surcharge',
    discount: 'Discount',
    totalAmount: 'Total Amount',
    detail: 'Detail',
    autoPaySignup: 'Sign Up For Automatic Payments',
    autoPaymentContent: 'Check box, and click Update Autopay Status to turn autopay on. \n Unchecked box and click Update Autopay Status to turn autopay off.',
    updateAutoPayStatus: 'Update AutoPay Status or Card Details',
    selectCardType: 'Select Card Type',
    cardholderName: 'Cardholder Name',
    cardholderAddress: 'Cardholder Address',
    zipCode: 'Zip Code',
    creditCardNumber: 'Credit Card Number',
    expirationDate: 'Expiration Date',
    enableAutopay: 'Enable Autopay',
    enterAddress: 'Enter Address',
    enterZipCode: 'Enter Zip Code',
    enterCardNumber: 'Enter Card Number',
    selectMonth: 'Select Month',
    cvv: 'CVV',
    enterCvv: 'Enter CVV',
    signUpSuccess: 'You have successfully signed up for autopay.',
    goToHome: 'Go To Home',
    thankyou: 'Thank You',
    enterFirstName: 'Enter First Name',
    enterAddressLine1: 'Enter Address Line 1',
    enterAddressLine2: 'Enter Address Line 2',
    enterCity: 'Enter City',
    city: 'City',
    state: 'State',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    firstName: 'First Name',
    lastName: 'Last Name',
    enterLastName: 'Enter Last Name',
    tenantInformation: 'Tenant Information',
    undoChanges: 'Undo Changes',
    tenantInfoSuccess: 'Tenant information updated successfully!',


    //reserve/moveIn Form
    reserveFormTitle: 'Tenant Information',
    alternateSectionTitle: 'Alternate Contact',
    unitSectionTitle: 'Unit Information',
    stateProvince: 'State / Province',
    selectState: 'Select State',
    licenseNumber: `Driver's License Number`,
    enterLicenseNumber: `Enter Driver's License Number`,
    licenseExpiration: `Driver's License Expiration Date`,
    selectLicenseExpiration: 'Select License Expiration Date',
    birthDate: 'Birth Date',
    dateFormat: 'DD-MM-YYYY',
    militaryType: 'Military Type',
    selectMilitaryType: 'Select Military Type',
    militaryBranch: 'Military Branch',
    selectMilitaryBranch: 'Select Military Branch',
    militaryID: 'Military Id#',
    enterMilitaryID: 'Enter Military Id',
    militaryDeployedDate: 'Military Deployed Until Date',
    militaryDivision: 'Military Division/Unit',
    enterMilitaryDivision: 'Enter Military Division/Unit',
    commandingOfficer: 'Military Commanding Officer',
    enterCommandingOfficer: 'Enter CO Name',
    commandingOfficerNumber: 'Military CO Number',
    enterCommandingOfficerNumber: 'Enter CO Phone Number',
    unitType: 'Unit Type',
    selectUnitType: 'Select Unit Type',
    insuranceType: 'Insurance Type',
    selectInsuranceType: 'Select Insurance Type',
    period: 'Period',
    moveInDate: 'Move In Date',
    selectPeriod: 'Select Period',
    proRate: 'ProRate Amount',
    setUpCost: 'Setup Cost',
    totalCharges: 'Total Charges',
    premium: 'Premium',
    moveBtnLabel: 'Pay and Complete Move In',
    reserveBtnLabel: 'Pay and Complete Reservation',
    moveAmtLabel: 'Total Move In Fee',
    reserveAmtLabel: 'Total Reservation Fee',
    storageUnitRates: 'Storage Unit Rates',
    reservationCharges: 'Reservation Charges',


    //thankyou
    thankYou: 'Thank You!',
    agreementText: `Please check your email to sign in the lease agreement. Your move in is not complete
    without a signed lease agreement.`,
    reserveText: ` One of our friendly and
    knowledgeable staff will get in touch shortly to confirm your details!
    We look forward to meeting you!`,
};
